// extracted by mini-css-extract-plugin
var _1 = "ExternalServiceCard-module__premiumBadge--NM0kO";
export { _1 as "premiumBadge" }
